import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { ProductPageSubNav } from "@/patterns/global-nav/src/nav-product-page";

const NonprofitLogo = () => {
    const logoCss = css({
        display: "inline !important",
        fontSize: "1.25rem",
        padding: "26px 0 20px 0",
        fontWeight: 600
    });
    return <span css={logoCss}>Nonprofits</span>;
};

export const NonprofitNav = () => {
    const intl = useIntl();

    const eligibilityHref = useLocalizedHref(
        "/teams/nonprofits/discount-pricing"
    );
    const supportPrograms = useLocalizedHref(
        "/teams/nonprofits/support-programs"
    );
    const resource = useLocalizedHref("/teams/nonprofits/resources");

    return (
        <UFOSegment name="nonprofit-nav">
            <ProductPageSubNav
                isShowTryNowLink={false}
                productLogoUrl="/teams/nonprofits"
                productLogo={<NonprofitLogo />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "NonprofitPageTemplate.navbar.nonprofit-logo",
                    defaultMessage: "Nonprofit logo"
                })}
                mobileLogo={<NonprofitLogo />}
                productPageNavLinks={[
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "NonprofitPageTemplate.navbar.pricing",
                            defaultMessage: "Eligibility and pricing"
                        }),
                        hasSubnav: false,
                        productKey: "nonprofit",
                        href: eligibilityHref
                    },
                    {
                        globalLinksKey: "support",
                        linkText: intl.formatMessage({
                            id: "NonprofitPageTemplate.navbar.support",
                            defaultMessage: "Support programs"
                        }),
                        hasSubnav: false,
                        productKey: "nonprofit",
                        href: supportPrograms
                    },
                    {
                        globalLinksKey: "resources",
                        linkText: intl.formatMessage({
                            id: "NonprofitPageTemplate.navbar.resources",
                            defaultMessage: "Resources"
                        }),
                        hasSubnav: false,
                        productKey: "nonprofit",
                        href: resource
                    }
                ]}
                mobileLinksSections={[
                    {
                        mobileLinkKey: "mobile-nonprofit",
                        mobileLinksProps: [
                            {
                                globalLinksKey: "pricing",
                                linkText: intl.formatMessage({
                                    id: "NonprofitPageTemplate.navbar.pricing",
                                    defaultMessage: "Eligibility and pricing"
                                }),
                                hasSubnav: false,
                                productKey: "nonprofit",
                                href: eligibilityHref
                            },
                            {
                                globalLinksKey: "support",
                                linkText: intl.formatMessage({
                                    id: "NonprofitPageTemplate.navbar.support",
                                    defaultMessage: "Support programs"
                                }),
                                hasSubnav: false,
                                productKey: "nonprofit",
                                href: supportPrograms
                            },
                            {
                                globalLinksKey: "resources",
                                linkText: intl.formatMessage({
                                    id: "NonprofitPageTemplate.navbar.resources",
                                    defaultMessage: "Resources"
                                }),
                                hasSubnav: false,
                                productKey: "nonprofit",
                                href: resource
                            }
                        ]
                    }
                ]}
            />
        </UFOSegment>
    );
};
